export const myFoldersInitValue = {
  data: {
    currentFolder: undefined,
    foldersCount: 0,
    documentsCount: 0,
    folders: [],
    documents: [],
    isLoading: false,
  },
  actions: {
    handleChangePage: () => {},
    handleAddFolder: () => {},
    handleOpenFolder: () => {},
    handleEditFolder: () => {},
    handleDownloadFolder: () => {},
    handleDeleteFolder: () => {},
    handleNavigateToFolder: () => {},
  },
};
